import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auth
export const exchangeSession = (session_id) =>
  api.post("/auth/session", { session_id }).then((r) => r.data);
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const logout = () => api.post("/auth/logout").then((r) => r.data);

// Assessments (async job flow)
export const createAssessment = (payload) =>
  api.post("/assessments", payload).then((r) => r.data);
export const getAssessmentStatus = (id) =>
  api.get(`/assessments/${id}/status`).then((r) => r.data);
export const getLatestAssessment = () =>
  api.get("/assessments/latest").then((r) => r.data);
export const listAssessments = () =>
  api.get("/assessments").then((r) => r.data.assessments);
export const getAssessment = (id) =>
  api.get(`/assessments/${id}`).then((r) => r.data);
export const toggleTask = (assessmentId, findingId) =>
  api
    .patch(`/assessments/${assessmentId}/tasks/${findingId}`)
    .then((r) => r.data);
export const reportUrl = (id) => `${API}/assessments/${id}/report`;
export const simulateScore = (id, resolvedFindingIds) =>
  api
    .post(`/assessments/${id}/simulate`, {
      resolved_finding_ids: resolvedFindingIds,
    })
    .then((r) => r.data);

// Competitors
export const getCompetitors = (id) =>
  api.get(`/assessments/${id}/competitors`).then((r) => r.data);
export const refreshCompetitors = (id) =>
  api.post(`/assessments/${id}/competitors/refresh`).then((r) => r.data);
export const replaceCompetitor = (id, slot) =>
  api.post(`/assessments/${id}/competitors/${slot}/replace`).then((r) => r.data);

// Widget
export const getWidget = (id) =>
  api.get(`/assessments/${id}/widget`).then((r) => r.data);
export const updateWidget = (id, patch) =>
  api.patch(`/assessments/${id}/widget`, patch).then((r) => r.data);
export const publicVerifyUrl = (token) => `${API}/public/verify/${token}`;
export const publicWidgetSvgUrl = (token, layout = "card", theme = "dark") =>
  `${API}/public/widget/${token}.svg?layout=${layout}&theme=${theme}`;

// Meta / Integrations
export const getIntegrationStatus = () =>
  api.get("/integrations/status").then((r) => r.data);

// Digest
export const getDigestPreferences = () =>
  api.get("/digest/preferences").then((r) => r.data);
export const updateDigestPreferences = (patch) =>
  api.put("/digest/preferences", patch).then((r) => r.data);
export const previewDigest = () =>
  api.post("/digest/preview").then((r) => r.data);
export const digestHistory = () =>
  api.get("/digest/history").then((r) => r.data.digests);
export const getDigest = (id) => api.get(`/digest/${id}`).then((r) => r.data);
export const sendTestDigest = () =>
  api.post("/digest/send-test").then((r) => r.data);
export const runScheduler = () =>
  api.post("/digest/run-scheduler").then((r) => r.data);
